export default __webpack_public_path__ + "static/media/IMG_0366.99971223.PNG";